import { render } from "./SidebarItem.vue?vue&type=template&id=ae7f0d0a"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=ae7f0d0a&lang=css"

import exportComponent from "C:\\work\\01_product\\05_konoike\\01_src\\2024_4th\\stg\\ConcreteOperationManagement\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/MCZSidebarPlugin/SidebarItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ae7f0d0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ae7f0d0a', __exports__)) {
    console.log('reload')
    api.reload('ae7f0d0a', __exports__)
  }
  
  module.hot.accept("./SidebarItem.vue?vue&type=template&id=ae7f0d0a", () => {
    console.log('re-render')
    api.rerender('ae7f0d0a', render)
  })

}


export default __exports__